<script>
  import { onMount, tick } from "svelte";
  import { fade } from "svelte/transition";
  import Timeline from "./Timeline.svelte";
  import Map from "./Map.svelte";

  onMount(async () => {
    setTimeout(function() {
      document.getElementsByTagName("body")[0].style.opacity = 1;

      setTimeout(async () => {
        await tick();
        active_stats = "deaths";

        all_stats = ninetydays_stats_data;
        stats = all_stats[0];
      }, 300);
    }, 300);
    loadAllStats();
    loadIncidents();
    loadMapStats(90);
    loadNews("all");
  });

  const loadAllStats = () => {
    //provStats = [];
    statsLoading = true;
    fetch("https://server.speensoft.net/riv/stats.json")
      .then(r => {
        return r.json();
      })
      .then(r => {
        let res = r.map(itm => itm.json);
        all_stats_data = res.filter(itm => itm.d == "all");
        ninetydays_stats_data = res.filter(itm => itm.d == "ninety");
        month_stats_data = res.filter(itm => itm.d == "thirty");
        week_stats_data = res.filter(itm => itm.d == "seven");
        changeTime();
        statsLoading = false;
      })
      .catch(error => {
        console.error("Error:", error);
        statsLoading = false;
      });
  };

  const loadIncidents = () => {
    //provStats = [];
    incidentsLoading = true;
    fetch("https://n8n.speensoft.net/webhook/riv_total_incidents")
      .then(r => {
        return r.json();
      })
      .then(res => {
        total_incidents_by_all = res;
        incidentsLoading = false;
      })
      .catch(error => {
        console.error("Error:", error);
        incidentsLoading = false;
      });
  };

  const loadMapStats = d => {
    provStats = [];
    mapLoading = true;
    fetch("https://n8n.speensoft.net/webhook/riv_province_stats?t=" + d)
      .then(r => {
        return r.json();
      })
      .then(res => {
        provStats = res;
        mapLoading = false;
      })
      .catch(error => {
        console.error("Error:", error);
        mapLoading = false;
      });
  };

  const loadNews = prov => {
    if (prov == "all") {
      if (allNews.length > 0) {
        selectedNews = allNews;
        if (newsLoading) cancelled = true;
        newsLoading = false;
      } else {
        selectedNews = [];
        if (newsLoading) cancelled = true;

        newsLoading = true;
        fetch("https://n8n.speensoft.net/webhook/riv_get_news")
          .then(r => {
            return r.json();
          })
          .then(res => {
            allNews = res;
            selectedNews = res;
            newsLoading = false;
          })
          .catch(error => {
            console.error("Error:", error);
            selectedNews = [];
            newsLoading = false;
          });
      }
    } else {
      if (!newsLoading) {
        selectedNews = [];

        newsLoading = true;
        fetch(
          "https://n8n.speensoft.net/webhook/riv_get_news_prov?prov=" + prov
        )
          .then(r => {
            return r.json();
          })
          .then(res => {
            provNews = res;
            if (!cancelled) selectedNews = res;
            cancelled = false;
            newsLoading = false;
          })
          .catch(error => {
            console.error("Error:", error);
            selectedNews = [];
            newsLoading = false;
          });
      }
    }
  };

  let cancelled = false;

  let provNews = [];
  let allNews = [];
  let selectedNews = [];
  let newsLoading = false;

  let provStats = [];
  let mapLoading = false;

  $: active_stats, toggleStats();

  const toggleStats = () => {
    if (active_stats == "deaths") stats = all_stats[0];
    else stats = all_stats[1];
  };

  $: active_menu, changeTime(true);

  const changeTime = reload => {
    // active_stats = "deaths";
    if (active_menu == "ninetydays") {
      all_stats = ninetydays_stats_data;
      if (reload) loadMapStats(90);
      //   stats = all_stats[0];
    } else if (active_menu == "week") {
      all_stats = week_stats_data;
      if (reload) loadMapStats(7);
      //   stats = all_stats[0];
    } else if (active_menu == "month") {
      all_stats = month_stats_data;
      if (reload) loadMapStats(30);
      //   stats = all_stats[0];
    } else if (active_menu == "overall") {
      all_stats = all_stats_data;
      if (reload) loadMapStats(9999);
      //   stats = all_stats[0];
    }
    toggleStats();
  };

  let ninetydays_stats_data = [];
  let week_stats_data = [];
  let month_stats_data = [];
  let all_stats_data = [];

  const showProvStats = e => {
    if (e.detail == "all") {
      changeTime();
      loadNews("all");
    } else {
      let ret;

      ret = provStats.filter(
        itm => parseInt(itm.prov) == parseInt(provinces[e.detail - 1][0])
      );
      if (ret.length != 0) {
        all_stats = ret;
      } else {
        all_stats = [
          { type: "deaths", civilian: 0, andsf: 0, taliban: 0, coalition: 0 },
          { type: "injuries", civilian: 0, andsf: 0, taliban: 0, coalition: 0 }
        ];
      }
      toggleStats();
      loadNews(provinces[e.detail - 1][0]);
    }
  };

  let active_menu = "ninetydays";
  let active_stats = "deaths";
  let all_stats = [
    { type: "deaths", civilian: 0, andsf: 0, taliban: 0, coalition: 0 },
    { type: "injuries", civilian: 0, andsf: 0, taliban: 0, coalition: 0 }
  ];
  let stats = all_stats[0];

  let total_incidents_by_all = [];

  let statsLoading = true;
  let incidentsLoading = true;

  $: total_incidents = total_incidents_by_all.map(itm => {
    return {
      x: itm.x,
      y:
        (parseInt(itm["Taliban"]) || 0) +
        (parseInt(itm["ANDSF"]) || 0) +
        (parseInt(itm["Others"]) || 0) +
        (parseInt(itm["US-Led Coalition"]) || 0)
    };
  });

  let expandedTimeline = false;
  let stats_total = 0;
  $: if (stats) {
    stats_total =
      stats.civilian + stats.andsf + stats.taliban + stats.coalition;
  }

  let openedItem = {};
  let provContainer;

  $: if (provContainer) {
    //  if (openedItem.id) {
    // window.provContainer = provContainer;

    let provs = document.getElementsByClassName("pth");
    let prov_orig = [...provs].filter(
      item =>
        item.dataset.id ==
        provinces.findIndex(prov => prov[0] == openedItem.prov) + 1
    )[0];
    if (prov_orig) {
      let prov = prov_orig.cloneNode(true);

      let bb = prov_orig.getBBox();
      prov.setAttributeNS(
        null,
        "class",
        prov.getAttributeNS(null, "class").replace("pth", "")
      );
      prov.style.transform =
        "translate(-" + parseInt(bb.x) + "px,-" + parseInt(bb.y) + "px)";
      provContainer.textContent = "";
      provContainer.setAttributeNS(
        null,
        "viewBox",
        "0 0 " + parseInt(bb.width) + " " + parseInt(bb.height)
      );
      provContainer.appendChild(prov);
    }
    //}
  }

  const getProvName = id => {
    let pr = provinces[
      provinces.findIndex(prov => prov[0] == openedItem.prov)
    ][1];
    return pr;
  };

  //     import { page } from '$app/stores'
  // const embed = $page.url.searchParams('embed');
    const urlParams = new URLSearchParams(window.location.search);
    const isEmbed = urlParams.get('embed')== "true";

</script>

<style>

</style>

<main>
  <div class="scroll" />

  <div class="main_bg" />
  {#if expandedTimeline || openedItem.id}
    <div
      class="ignore black_bg"
      class:transparent={openedItem.id}
      on:click={() => {
        expandedTimeline = false;
        openedItem = {};
      }} />
  {/if}
  {#if isEmbed}
    <h3 style=" margin-left: 42px; top: 18px; position:absolute">APW Reports</h3>
  {:else}

  <div class="logo" />
{/if}
  <div class="main_container">
    <ul class="menu unselectable">
      <li
        style="width:90px"
        class:active={active_menu == 'week'}
        on:click={() => (active_menu = 'week')}>
        Seven Days
      </li>
      <li
        style="width:100px"
        class:active={active_menu == 'month'}
        on:click={() => (active_menu = 'month')}>
        Thirty Days
      </li>
      <li
        style="width:86px"
        class:active={active_menu == 'ninetydays'}
        on:click={() => (active_menu = 'ninetydays')}>
        90 Days
      </li>
      <li
        class:active={active_menu == 'overall'}
        on:click={() => (active_menu = 'overall')}>
        Overall
      </li>
    </ul>
    {#if !expandedTimeline}
      <div
        on:click={() => (expandedTimeline = false)}
        style="height: calc(100vh - 260px); min-height: 560px; display: flex;
        align-items: center; justify-content: space-around;">
        {#if !isEmbed}
        <div class="stats_box unselectable" class:narrow={openedItem.id}>
          <ul class="menu red" style="z-index:0;">
            <li
              class="ignore"
              class:active={active_stats == 'deaths'}
              on:click|preventDefault|stopPropagation={() => (active_stats = 'deaths')}>
              Deaths
            </li>
            <li
              class="ignore"
              class:active={active_stats == 'injuries'}
              on:click|preventDefault|stopPropagation={() => (active_stats = 'injuries')}>
              Injuries
            </li>
          </ul>
          {#if statsLoading}
            <div style="margin-top:60px;" class="loader" />
          {/if}
          {#if stats}
            <div
              style="position: absolute; left: 0; right: 50%; top: 68px; bottom:
              0;">
              <div
                style="margin-top: 16px; font-size: 22pt; font-weight: bold;
                color: #d7d9dc; text-align: center;">
                Total
              </div>
              <div
                style=" text-align: right; font-family: Georgia; font-size:
                20pt; font-weight: bold; color: #cb001c; margin-top: -1px;
                margin-right: 20px; ">
                {stats_total}
              </div>
              <div class="avatar_box civilian">
                <img src="images/soldiers/civilian.png" />
                <img
                  src="images/soldiers/civilian.png"
                  class="overlay"
                  style={'clip: rect(' + parseInt(114 - (stats.civilian / stats_total) * 114) + 'px, 300px, 300px, 0px);'} />
                <div class="count" style="margin-top: 24px; margin-left: 8px;">
                  {stats.civilian}
                </div>
                <div
                  class="type"
                  style="margin-left: 8px; margin-top: -4px; display: block;">
                  Civillians
                </div>
              </div>
            </div>

            <div
              style="position: absolute; left: 50%; right: 0; top: 68px; bottom:
              0;">
              <div class="avatar_box" style="margin-top: 24px;">
                <img src="images/soldiers/ANDSF.png" />
                <img
                  src="images/soldiers/ANDSF.png"
                  class="overlay"
                  style={'clip: rect(' + parseInt(72 - (stats.andsf / stats_total) * 72) + 'px, 300px, 300px, 0px);'} />
                <div class="count">{stats.andsf}</div>
                <div class="type">ANDSF</div>
              </div>
              <div class="avatar_box">
                <img
                  src="images/soldiers/taliban.png"
                  style="margin-left: -18px;" />
                <img
                  src="images/soldiers/taliban.png"
                  class="overlay"
                  style={'margin-left: -18px; clip: rect(' + parseInt(72 - (stats.taliban / stats_total) * 72) + 'px, 300px, 300px, 0px);'} />

                <div class="count">{stats.taliban}</div>
                <div class="type">Taliban</div>
              </div>
              <div class="avatar_box">
                <img src="images/soldiers/us.png" style="margin-left: -12px;" />
                <img
                  src="images/soldiers/us.png"
                  class="overlay"
                  style={'clip: rect(' + parseInt(72 - (stats.coalition / stats_total) * 72) + 'px, 300px, 300px, 0px);'} />
                <div class="count">{stats.coalition}</div>
                <div class="type">NATO</div>
              </div>
            </div>
          {/if}
        </div>
        {/if}

        <div class="map_box" class:narrow={openedItem.id}>
          {#if mapLoading}
            <div class="loader" />
          {/if}
          <Map stats={provStats} on:stats={showProvStats} />
        </div>
        <div class:expanded={openedItem.id} class="ignore news_box">
          {#if newsLoading}
            <div
              class="loader"
              style="margin-top:100px; opacity:0.4; position:absolute;
              margin-left:45%" />
          {/if}
          {#if openedItem.id}
            <div class="news_container" style="flex:1;">
              <div class="close" on:click={() => (openedItem = {})}>×</div>
              <div class="sidebar">
                <div>
                  {#if openedItem.attachments && openedItem.attachments.length > 0}
                    <img class="image" src={openedItem.attachments[0]} />
                  {/if}
                  <svg class="prov_container" bind:this={provContainer} />
                  <div class="prov_label">{getProvName(openedItem.prov)}</div>
                </div>
  {#if !isEmbed}
                <div>

                  <div class="medium" style="margin-top:50px; text-align:left">
                    Attack Initiated By:
                  </div>
                  <div
                    class="bold"
                    style=" margin-top: 40px; text-align: left; margin-left:
                    90px;">
                    {openedItem.incident_initiated_by}
                  </div>

                  {#if openedItem.incident_initiated_by == 'ANDSF'}
                    <img class="attacker" src="images/afg.png" alt="" />
                  {:else if openedItem.incident_initiated_by == 'Taliban'}
                    <img class="attacker" src="images/taliban.png" alt="" />
                  {:else if openedItem.incident_initiated_by == 'US-Led Coalition'}
                    <img class="attacker" src="images/nato.png" alt="" />
                  {/if}
                  <!-- <img class="attacker" src="images/Others.png" alt="" /> -->
                </div>
                <div
                  class="medium"
                  style="margin-bottom:40px; text-align:center">
                  Total Casualties:
                  <span
                    style=" font-family: Georgia; font-size: 16pt; font-weight:
                    bold; color: rgb(203, 0, 28);">
                    {openedItem.civilian + openedItem.andsf + openedItem.taliban + openedItem.coalition}
                  </span>
                </div>
            {/if}

              </div>
              <div class="date">
                {new Date(openedItem.incident_date).toDateString()}
              </div>

              <div class=" " style="font-size:13pt; margin:10px 0;">
                {openedItem.report_title_english}
              </div>

              <div class="date" style="font-size:10pt;margin-top:20px;">
                — By {openedItem.reported_by}, {getProvName(openedItem.prov)}
              </div>

              <div class="report_body">
                {@html openedItem.report_text_english.replace(/\n/g, '<div class="line" ></div>')}
                <!-- {@html openedItem.report_text_english.replace(/\n/g, '<div class="line" ></div>')} -->
              </div>

  {#if !isEmbed}
              <div class="report_stats">

                <div
                  style="display: flex; justify-content: space-evenly;
                  align-items: flex-end;">
                  <div class="avatar_box" style="margin-top: 24px;">
                    <img src="images/soldiers/civilian.png" />
                    <img
                      src="images/soldiers/civilian.png"
                      class="overlay"
                      style={'clip: rect(' + parseInt(72 - (openedItem.civilian / (openedItem.civilian + openedItem.andsf + openedItem.taliban + openedItem.coalition)) * 72) + 'px, 300px, 300px, 0px);'} />
                    <div class="count">
                      {openedItem.civilian}
                      {#if openedItem.civilian_inj > 0}
                        <span class="injured_count">
                          {openedItem.civilian_inj} injured
                        </span>
                      {/if}
                    </div>
                    <div class="type">Civilian</div>
                  </div>
                  <div class="avatar_box" style="margin-top: 24px;">
                    <img src="images/soldiers/ANDSF.png" />
                    <img
                      src="images/soldiers/ANDSF.png"
                      class="overlay"
                      style={'clip: rect(' + parseInt(72 - (openedItem.andsf / (openedItem.civilian + openedItem.andsf + openedItem.taliban + openedItem.coalition)) * 72) + 'px, 300px, 300px, 0px);'} />
                    <div class="count">
                      {openedItem.andsf}
                      {#if openedItem.andsf_inj > 0}
                        <span class="injured_count">
                          {openedItem.andsf_inj} injured
                        </span>
                      {/if}
                    </div>
                    <div class="type">ANDSF</div>
                  </div>
                  <div class="avatar_box">
                    <img
                      src="images/soldiers/taliban.png"
                      style="margin-left: -18px;" />
                    <img
                      src="images/soldiers/taliban.png"
                      class="overlay"
                      style={'margin-left: -18px; clip: rect(' + parseInt(72 - (openedItem.taliban / (openedItem.civilian + openedItem.andsf + openedItem.taliban + openedItem.coalition)) * 72) + 'px, 300px, 300px, 0px);'} />

                    <div class="count">
                      {openedItem.taliban}
                      {#if openedItem.taliban_inj > 0}
                        <span class="injured_count">
                          {openedItem.taliban_inj} injured
                        </span>
                      {/if}
                    </div>
                    <div class="type">Taliban</div>
                  </div>
                  <div class="avatar_box">
                    <img
                      src="images/soldiers/us.png"
                      style="margin-left: -12px;" />
                    <img
                      src="images/soldiers/us.png"
                      class="overlay"
                      style={'clip: rect(' + parseInt(72 - (openedItem.coalition / (openedItem.civilian + openedItem.andsf + openedItem.taliban + openedItem.coalition)) * 72) + 'px, 300px, 300px, 0px);'} />
                    <div class="count">
                      {openedItem.coalition}
                      {#if openedItem.coalition_inj > 0}
                        <span class="injured_count">
                          {openedItem.coalition_inj} injured
                        </span>
                      {/if}
                    </div>
                    <div class="type">NATO</div>
                  </div>
                </div>
              </div>
            {/if}
            </div>
          {/if}
          <div>
            <h1>Incidents</h1>

            <ul>
              {#each selectedNews as news}
                <li
                  class:opened={news.id == openedItem.id}
                  on:click={() => (openedItem = news)}>
                  <div class="date">
                    {new Date(news.incident_date).toDateString()}
                  </div>
                  <div class="title bold">{news.report_title_english}</div>
                  <div class="excerpt truncate-overflow">
                    {news.report_text_english}
                  </div>
                </li>
              {/each}
            </ul>
          </div>
        </div>
      </div>
    {/if}

    <div
      class:expanded={expandedTimeline}
      class="timeline_box unselectable"
      on:click={() => (expandedTimeline = true)}>

      <Timeline
        duration={active_menu}
        expanded={expandedTimeline}
        loading={incidentsLoading}
        {total_incidents}
        {total_incidents_by_all} />
    </div>
  </div>
</main>
